import { Injectable, inject } from '@angular/core';
import {ChatBotService} from '../services/chat-bot.service';

@Injectable({
  providedIn: 'root'
})
export class ChatBotSandbox {
  private readonly chatBotService = inject(ChatBotService);

  sendMessage = (message: string) => this.chatBotService.sendMessage(message);
}
